import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/tasks-checklist'

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })
  return response
}

export const get = async (_params) => {
  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: _params,
  })

  return response?.data
}

export const getByTasksId = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })
  return response?.data
}

export const remove = async (data) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })
  return response
}

export const show = async (tasksId) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${tasksId}`,
  })

  return response
}

export const migrateWorkOrder = async (taskId, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${taskId}/migrate`,
    data,
  })
  return response
}
